export default function() {

  const widgetName = 'cardWidgetFeaturedEvents';
  let widgetOpts;
  let maxItemsVisible = 8
  
  if (window.siteTheme === 'Amphitheater') {
    widgetOpts = cardWidgetAmpFeaturedEventsOpts;
  }
  if (window.siteTheme === 'Oncenter') {
    widgetOpts = cardWidgetOncFeaturedEventsOpts;
    maxItemsVisible = 4;
  } 

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(data, owl, hasData) {

      if (window.siteTheme === 'Amphitheater') {
        $(`#${widgetName}`).prepend('<h2 class="feature-title">Featured Events</h2>');
      }
      
      $(`#${widgetName}`).append('<div class="view-all-events"><a href="/events" class="view-events-btn">See All Events &gt;</a></div>');

      $(`#${widgetName} .card-widget-item`).each(function(i, item) {
        if (data.items[i].DateRange) {
          var rawDate = data.items[i].DateRange.slice(0, 7);
          var m = rawDate.slice(0, 4).trim();
          var d = rawDate.replace(",", "").slice(-3).trim();

          $(this).prepend(`
            <div class="card-widget-date">
              <span>${m}</span>
              <span>${d}</span>
            </div>
          `);
        }
      });
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: ['image'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: maxItemsVisible,
    moreButton: {
      visible: true,
      text: 'Buy Tickets'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: false,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: true,
      margin: 10,
      navText: ['Prev','Next'],
      nav: true
    },
    textOverImage: false
  });

}